function getBreakpointsFromValues(values, breakpointLabels) {
    return values.reduce((acc, cur, index) => {
        if (cur) {
            return acc.concat({
                breakpoint: breakpointLabels[index],
                value: cur
            });
        }
        else {
            return acc;
        }
    }, []);
}
export default getBreakpointsFromValues;
//# sourceMappingURL=getBreakpointsFromValues.js.map